module.exports = __webpack_public_path__ + "static/media/perdida-beneficio.017c3982.svg";